module.exports = __webpack_public_path__ + "static/zapier_logo.4c254df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/zapier_logo.png
// module id = 1895
// module chunks = 253011397747672